
import { instantiate } from './DiWAN3-indigo3.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


